var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"height":"100%"}},[_c('van-nav-bar',{attrs:{"title":"活动说明","left-text":"","left-arrow":""},on:{"click-left":function($event){return _vm.onClickLeft()}}}),_c('div',{staticClass:"dial"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }